/* eslint-disable @1js/office-online-rules/no-v8-imports-for-fluentui */
import type { IButtonStyles } from "@fluentui/react";
import { defaultLargeButtonMinWidth } from "./defaultStylingConstants";

export const smallActionButtonHeight = 24;

const smallButtonStyles: IButtonStyles = {
  root: {
    height: smallActionButtonHeight,
    minWidth: 24,
    padding: 1,
  },
  flexContainer: {
    justifyContent: "flex-start",
  },
  icon: {
    width: 16,
    height: 16,
    lineHeight: 16,
    marginLeft: 2,
    marginRight: 0,
    fontSize: 16,
  },
  textContainer: {
    fontSize: 12,
    marginLeft: 4,
    marginRight: 0,
  },
  label: {
    margin: 0,
  },
  menuIcon: {
    width: 8,
    height: 8,
    lineHeight: 8,
    fontSize: 8,
    marginLeft: 4,
    marginRight: 0,
    display: "block",
    selectors: {
      svg: {
        display: "block",
      },
    },
  },
};

const largeActionButtonHeight = 72;

const largeButtonStyles: IButtonStyles = {
  root: {
    position: "relative",
    padding: 1,
    height: largeActionButtonHeight,
    minWidth: defaultLargeButtonMinWidth,
  },
  flexContainer: {
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  icon: {
    width: 32,
    height: 32,
    lineHeight: 32,
    fontSize: 32,
  },
  textContainer: {
    wordWrap: "normal",
    fontSize: 12,
    marginTop: 2,
    lineHeight: "normal",
  },
  label: {
    margin: 0,
  },
};

export const actionButtonStylingConstants = {
  defaultSizedControlStyles: {
    small: smallButtonStyles,
    large: largeButtonStyles,
  },
  largeActionButtonHeight,
};
